import { UserRepo } from "../domain/UserRepo";

export interface ToggleUserActiveScreenData {
  ui_loading: boolean;
  error_message: string;
  success_message: string;
}

export class ToggleUserActiveCommand {
  constructor(
    private userRepo: UserRepo,
    private screenData: ToggleUserActiveScreenData
  ) {}

  async execute(userId: number, isActive: boolean, companydb_id?: number): Promise<boolean> {
    this.screenData.ui_loading = true;
    this.screenData.error_message = '';
    this.screenData.success_message = '';

    try {
      const result = await this.userRepo.toggleActive(userId, isActive, companydb_id);

      if (result.status !== 'ok') {
        this.screenData.error_message = result.message || 'Error al cambiar estado del usuario';
        return false;
      }

      this.screenData.success_message = `Usuario ${isActive ? 'activado' : 'desactivado'} correctamente`;
      return true;
    } catch (error: any) {
      this.screenData.error_message = error.message || 'Error al cambiar estado del usuario';
      return false;
    } finally {
      this.screenData.ui_loading = false;
    }
  }
}
